/**
 * Detect fn
 */
export default () => 'requestAnimationFrame' in self
